import React, { useContext } from 'react';
import Route from './Route';
import EnvironmentVariablesContext
  from '../contexts/EnvironmentVariablesContext';

export default function GuestRoute(props) {
  const environmentVariables = useContext(EnvironmentVariablesContext);

  return (
    <Route
      authenticated={false}
      redirectPath={environmentVariables.REACT_APP_LOGIN_REDIRECT_PATH}
      {...props}
    />
  );
}
